import {
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILED,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  GET_USER_FAILED,
} from './actionTypes';

const initialState = {
  loading: false,
  error: '',
  user: null,
  organizations: [],
};

const rolesSelectReducer = (state = initialState, {
  type, error, user, organizations,
}) => {
  switch (type) {
    case GET_USER_REQUEST:
      return {
        ...state,
        user: null,
        loading: true,
      };
    case GET_USER_SUCCESS:
      return {
        ...state,
        user,
        organizations: organizations || [],
        loading: false,
      };
    case GET_USER_FAILED:
      return {
        ...state,
        error,
        loading: false,
      };
    case UPDATE_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_USER_FAILED:
      return {
        ...state,
        error,
        loading: false,
      };
    default:
      return state;
  }
};

export default rolesSelectReducer;
